import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2100; /* Acima do modal de conta */
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(3px);
`;

export const Container = styled.div`
  background: #252525;
  width: 450px;
  padding: 30px;
  border-radius: 8px;
  border: 1px solid #e6aa3a;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);
  animation: ${slideIn} 0.3s ease;
  color: #fff;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #444;
  padding-bottom: 10px;

  h3 {
    margin: 0;
    color: #e6aa3a;
  }

  button {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    &:hover {
      color: #e6aa3a;
    }
  }
`;

export const InfoBox = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  p {
    margin: 5px 0;
    strong {
      color: #e6aa3a;
    }
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;

  label {
    display: block;
    color: #ccc;
    margin-bottom: 5px;
    font-size: 14px;
  }

  textarea,
  input {
    width: 100%;
    padding: 10px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid #444;
    border-radius: 4px;
    color: #fff;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }

  textarea {
    min-height: 80px;
    resize: vertical;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  background: #e6aa3a;
  border: none;
  color: #111;
  font-weight: bold;
  padding: 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  transition: background 0.2s;

  &:hover {
    background: #ffc300;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
